export default __webpack_public_path__ + "static/media/ivr_active.950c9805.svg";